import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import CounterUpComponent from "../components/CounterUpComponent";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "../../App.css"

const Successstories = () => {
  const sendmail = () => {
    var link =
      "mailto:info@myprega.com" +
      "?cc=" +
      "&subject= About subscription" +
      "&body=" +
      encodeURIComponent("\n");
    window.location.href = link;
  };
  const options = {
    items: 2,
    loop: true,
    autoplay: true,
    autoplayTimeout: 4000,
    dots: false,
    nav: false,

    responsive: {
      0: { items: 1 },
      576: { items: 1 },
      768: { items: 1 },
      1200: { items: 2 },
    },
  };
  return (
    <>
      <div
        style={{
          backgroundImage: 'url("/heroimg3.jpg")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",

          width: "100%",
          // backgroundAttachment: 'fixed',
        }}
      >
        <div className="container py-5">
          <div className="">
            <h3 className="hero-title text-center">
              Our success stories:
              <span className="blue">
                {" "}
                From the voice of mom and mom buddies
              </span>
            </h3>
            <h4 className="underlineone text-secondary hero_subtitle text-center d-flex align-items-center justify-content-center m-auto">
              Don't just take our word for it, Our moms love our care just as
              much as we do
            </h4>
            
            <div className="text-center p-4">
            <h2 className="hero-title text-center">
            Loved & Trusted by Moms: 4.9<i className="bi bi-star-fill as"></i>
            </h2>
            {/* <h2 className="hero-title text-center">
                Our <span style={{ color: "#4285F4" }}>G</span>
                <span style={{ color: "#EA4335" }}>o</span>
                <span style={{ color: "#FBBC05" }}>o</span>
                <span style={{ color: "#4285F4" }}>g</span>
                <span style={{ color: "#34A853" }}>l</span>
                <span style={{ color: "#EA4335" }}>e</span> Rating: 4.9<i className="bi bi-star-fill as"></i>
             </h2> */}

               <a
                 href="https://maps.app.goo.gl/zDL18q6p1FJV6Wma7?g_st=com.google.maps.preview.copy"
                 target="_blank"
                 rel="noopener noreferrer"
                 className="mt-0 inline-block bg-blue-600 text-white px-6 py-2 rounded-lg shadow-lg hover:bg-blue-700 transition"
               >
                 {/* Check Our Reviews */}
                 See Why Moms Trust Us
               </a>
             </div>

            <span className="mb-3 pl-3">
              <br />
            </span>
            <div className="container bg-secondary"></div>
            <div className="container">
              <div className="row py-5 align-items-center">
                <div className="col-md-8">
                  <OwlCarousel className="owl-theme" {...options}>
                  <div className="item abc">
                   <div className="review-container">
                     <div className="review-image">
                       <img src="/customer1.jpg" alt="Customer" />
                     </div>
                     <div className="review-text">
                       <p>
                          I like the easy access to my 
                          daily pregnancy records, alerts on when consultation
                          and labs are due, and the opportunity to ask questions
                          anytime. myprega simplified my pregnancy journey.
                       </p>
                       <div className="review-stars">
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                       </div>
                       {/* <p className="customer-name">- Customer Name</p> */}
                     </div>
                   </div>
                  </div>

                  <div className="item abc">
                   <div className="review-container">
                     <div className="review-image">
                       <img src="/customer2.jpg" alt="Customer" />
                     </div>
                     <div className="review-text">
                       <p>
                         The responsibility of caring for pregnant mothers lies
                          on the shoulders of family, public health systems and
                          on volunteers, who often struggle to navigate
                          unorganised care and myprega is the only solution for
                          this problem.
                       </p>
                       <div className="review-stars">
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                       </div>
                       {/* <p className="customer-name">- Customer Name</p> */}
                     </div>
                   </div>
                  </div>

                  <div className="item abc">
                   <div className="review-container">
                     <div className="review-image">
                       <img src="/customer3.jpg" alt="Customer" />
                     </div>
                     <div className="review-text">
                       <p>
                      myprega is changing the traditional pregnancy care
                          with their technology driven solution and I'm proud to
                          be pioneers for this vision.
                       </p>
                       <div className="review-stars">
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                       </div>
                       {/* <p className="customer-name">- Customer Name</p> */}
                     </div>
                   </div>
                  </div>


                  <div className="item abc">
                   <div className="review-container">
                     <div className="review-image">
                       <img src="/customer4.jpg" alt="Customer" />
                     </div>
                     <div className="review-text">
                       <p>
                        At myprega, nothing is out of reach when it comes to
                          getting connected to your doctor. Incredible, how
                          everything in my journey is too organised.
                       </p>
                       <div className="review-stars">
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                       </div>
                       {/* <p className="customer-name">- Customer Name</p> */}
                     </div>
                   </div>
                  </div>

                  <div className="item abc">
                   <div className="review-container">
                     <div className="review-image">
                       <img src="/customer4.jpg" alt="Customer" />
                     </div>
                     <div className="review-text">
                       <p>
                       Myprega’s approach is the future of pregnancy care. Their use of technology to monitor daily
                       health, team of 9 different medical specialist for each pregnant individual and provide
                       on-demand support is incredible. I haven’t come across anything like this in India. They’re
                       truly the best pregnancy partner for moms.
                       </p>
                       <div className="review-stars">
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                       </div>
                       <p className="customer-name">- Rithika Pillai</p>
                     </div>
                   </div>
                  </div>

                  <div className="item abc">
                   <div className="review-container">
                     <div className="review-image">
                       <img src="/customer3.jpg" alt="Customer" />
                     </div>
                     <div className="review-text">
                       <p>
                       The Myprega team went above and beyond to make my pregnancy comfortable. The diet
                       plan was personalized for my needs, and the yoga sessions kept me active. Their
                       user-friendly pregnancy care platform is amazing—tracking my health and appointments was
                       so easy. It felt like having a personal pregnancy assistant.
                       </p>
                       <div className="review-stars">
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                       </div>
                       <p className="customer-name">- Gayatri Navale</p>
                     </div>
                   </div>
                  </div>

                  <div className="item abc">
                   <div className="review-container">
                     <div className="review-image">
                       <img src="/customer1.jpg" alt="Customer" />
                     </div>
                     <div className="review-text">
                       <p>
                       Choosing Myprega was the best decision I made for my wife’s pregnancy journey. Their
                       doctors are so knowledgeable yet so kind. They made us feel like family, not just a patient.
                       From consultations to ultrasounds, everything was perfectly organized through their tech
                       platform, and I didn’t have to worry about a thing. The daily health tracking feature gave us so
                       much peace of mind!
                       </p>
                       <div className="review-stars">
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                       </div>
                       <p className="customer-name">- Garad</p>
                     </div>
                   </div>
                  </div>

                  <div className="item abc">
                   <div className="review-container">
                     <div className="review-image">
                       <img src="/customer3.jpg" alt="Customer" />
                     </div>
                     <div className="review-text">
                       <p>
                       I had a few complications during my pregnancy, and Myprega was there for me every step of
                       the way. Their 24/7 support and organized care managed through their innovative
                       technology platform made all the difference. The team is truly compassionate, and all the 9
                       doctors panel are the best I’ve ever met! Their doctors and team treat me like family in my
                       whole pregnancy journey. Highly recommended.
                       </p>
                       <div className="review-stars">
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                       </div>
                       <p className="customer-name">-  Asha Gadge</p>
                     </div>
                   </div>
                  </div>

                  <div className="item abc">
                   <div className="review-container">
                     <div className="review-image">
                       <img src="/customer4.jpg" alt="Customer" />
                     </div>
                     <div className="review-text">
                       <p>
                      Myprega is a blessing for all pregnant women in Pune. They provide everything you need in
                       one package—consultations, tests, yoga, diet plans, and even emotional support. Their
                       technology managed all my schedules, reports and other things. I felt so loved and cared for
                       throughout my pregnancy. Their team and doctors treat me like family during whole
                       pregnancy journey.
                       </p>
                       <div className="review-stars">
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                       </div>
                       <p className="customer-name">-  Gayatri</p>
                     </div>
                   </div>
                  </div>

                  <div className="item abc">
                   <div className="review-container">
                     <div className="review-image">
                       <img src="/customer3.jpg" alt="Customer" />
                     </div>
                     <div className="review-text">
                       <p>
                      Pregnancy care in India has long needed an upgrade, and Myprega has stepped in to
                       transform it completely. Their integration of technology in pregnancy management is
                       unmatched. It’s inspiring to see such an innovative and empathetic approach to maternal
                       health. I’d choose Myprega without a second thought!
                       </p>
                       <div className="review-stars">
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                       </div>
                       <p className="customer-name">-  Pratiksha Pathare</p>
                     </div>
                   </div>
                  </div>

                  <div className="item abc">
                   <div className="review-container">
                     <div className="review-image">
                       <img src="/customer4.jpg" alt="Customer" />
                     </div>
                     <div className="review-text">
                       <p>
                       The Myprega package is worth every penny. Their transparency and care made me feel
                       secure throughout my pregnancy. The doctors were always so patient, answering all my
                       questions without rushing. I loved the personalized care plans and the constant support
                       through their innovative tech platform.
                       </p>
                       <div className="review-stars">
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                       </div>
                       <p className="customer-name">-  Dhanashree Korke</p>
                     </div>
                   </div>
                  </div>

                  <div className="item abc">
                   <div className="review-container">
                     <div className="review-image">
                       <img src="/customer3.jpg" alt="Customer" />
                     </div>
                     <div className="review-text">
                       <p>
                       The Garbhasanskar program was my favorite part of Myprega’s package. It was such a
                       beautiful way to connect with my baby. The team of 9 doctors of different specialities and
                       team were always so warm and caring. There innovative platform daily track my pregnancy
                       health which helps me to managed hypertension condition during pregnancy. Very innovative
                       way of delivering pregnancy care. I always feel like family. Highly recommend.
                       </p>
                       <div className="review-stars">
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                       </div>
                       <p className="customer-name">-  Gayatri</p>
                     </div>
                   </div>
                  </div>

                  <div className="item abc">
                   <div className="review-container">
                     <div className="review-image">
                       <img src="/customer4.jpg" alt="Customer" />
                     </div>
                     <div className="review-text">
                       <p>
                       I had a few complications during my pregnancy, and Myprega was there for me every step of
                       the way. Their 24/7 support and organized care managed through their innovative platform
                       made all the difference. The team is truly compassionate, and the doctors are the best I’ve
                       ever met. Five star rating to myprega.
                       </p>
                       <div className="review-stars">
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                       </div>
                       <p className="customer-name">-  Priya Misal</p>
                     </div>
                   </div>
                  </div>

                  <div className="item abc">
                   <div className="review-container">
                     <div className="review-image">
                       <img src="/customer3.jpg" alt="Customer" />
                     </div>
                     <div className="review-text">
                       <p>
                       Myprega's care package is incredible. Their doctors are so skillful and knowledgable. I had
                       access to regular consultations of 9 doctors of different specialities, diet plans, yoga
                       sessions, daily health tracking through their technology, and emergency support. What truly
                       sets them apart is their empathy and how they treat every mom like family. I never felt rushed
                       in any consultation, and the doctors were always available to answer my concerns. Truly a
                       revolutionary experience!
                       </p>
                       <div className="review-stars">
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                         <i className="bi bi-star-fill"></i>
                       </div>
                       <p className="customer-name">-  Mahamuni</p>
                     </div>
                   </div>
                  </div>


                  </OwlCarousel>
                </div>

                <div className="col-md-4 order-mobile">
                  <img src="/customerreview.gif" className="w-100" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-while">
        <div className="container py-5">
          <div className="">
            <div className="row">
              <h3 className="hero-title  text-center pb-5">
                Everyone has a tab open to <span>myprega.com</span>
              </h3>
              <div className="col-12 col-lg-4 text-center">
                <div className="element" style={{paddingBottom: '100px'}}>
                  <div className="top-border"></div>
                  <div className="d-flex flex-column content">
                    <div className="outerwrapper d-flex justify-content-center align-items-center">
                      <div className="sq">
                        <CounterUpComponent targetCount={162} duration={3000} />
                        <i className="bi bi-plus-lg"></i>{" "}
                      </div>
                    </div>
                    <h5 className="fw-bolder text-capitalize">
                      Medical experts
                    </h5>
                  </div>
                  <div className="bottom-border"></div>
                </div>
              </div>
              <div className="col-12 col-lg-4 text-center">
                <div className="element" style={{paddingBottom: '100px'}}>
                  <div className="top-border"></div>
                  <div className="d-flex flex-column content">
                    <div className="outerwrapper d-flex justify-content-center align-items-center">
                      <div className="sq">
                        <CounterUpComponent targetCount={606} duration={3000} />
                        <i className="bi bi-plus-lg "></i>{" "}
                      </div>
                    </div>
                    <h5 className="fw-bolder text-capitalize">mom</h5>
                  </div>
                  <div className="bottom-border"></div>
                </div>
              </div>
              <div className="col-12 mx-auto col-lg-4 text-center ">
                <div className="element" style={{paddingBottom: '100px'}}>
                  <div className="top-border"></div>
                  <div className="d-flex flex-column content">
                    <div className="outerwrapper d-flex justify-content-center align-items-center">
                      <div className="sq">
                        <CounterUpComponent
                          targetCount={2030}
                          duration={3000}
                        />
                        <i className="bi bi-plus-lg "></i>{" "}
                      </div>
                    </div>
                    <h5 className="fw-bolder text-capitalize">mom buddies</h5>
                  </div>
                  <div className="bottom-border"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="bg-light">
        <div className="container">
          <div className="mt-5">
            <div className="py-5">
              <div className="row align-items-center my-5">
                <div className="col-12 col-md-5">
                  <h3 className="hero-title" data-aos="zoom-in-down">
                    Are you someone, not a mom-to-be?
                  </h3>
                  <h3
                    className="hero-title"
                    style={{ fontWeight: "normal", color: "#a4113a" }}
                    data-aos="zoom-in-down"
                  >
                    Be mom buddy! Join Our Community!
                  </h3>

                  <div className="col-12 col-md-7 d-md-none">
                    <img src="/joinus.png" className="img-fluid" />
                  </div>

                  <Link
                    className="mLEFT buy mt-2 mt-md-0"
                    style={{ cursor: "pointer", color: "white" }}
                    onClick={sendmail}
                  >
                    SUBSCRIBE
                  </Link>
                </div>
                <div
                  className="col-12 col-md-7 d-none d-md-block"
                  data-aos="zoom-in-down"
                >
                  <img src="/joinus.png" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default Successstories;
